import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import Home from "./components/ExhibitorList";
import DetailPage from "./components/ExhibitorProfile/ExhibitorProfile";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const routes = [
  {
    name: "home",
    path: "/exhibitor-list",
    component: Home
  },
  {
    name: "home",
    path: "/ja/exhibitor-list",
    component: Home
  },
  {
    name: "ExhibitorDetails",
    path: "/exhibitordetails",
    component: DetailPage
  },
  {
    name: "ExhibitorDetails",
    path: "/ja/exhibitordetails",
    component: DetailPage
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return { selector: to.hash }; 
    }
    return { x: 0, y: 0 };
  },
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
